import React, { useEffect, useState, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { useLocation } from "react-router-dom";
import { LoadingScreen } from "../../../UiComponents/LoadingComponent";
import {UpdateorCancelButtons} from "./UpdateorCancelButtons";
import { UrlPath } from "../../../../config/routeConfig";
import { getContactsInfoAction,getParentCompaniesAction } from "../../../actions/contactsAction";
import { SBAComboBox, SBADropDown,SBAMultiSelectCheck} from "../../../UiComponents/SBADropDown";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import moment from "moment";
import  "../../../investor/investor.css";
import { insertorupdatecompany,getCompanyInfo,getBusinessUnits } from "../../../../config/apiConfig";
import { sbaAxios } from "../../../utils/sbaAxios";
import { SBNotify } from "../../../utils/sbNotify";
import { ToastContainer, toast } from 'react-toastify';
import {ContactGeneralAttributes} from "../../../../config/investorConfig";

export const GeneralInvestmentCompanyEdit = (props) => {

  const emptyCompanyDetails={
    salutation: "",   
    companyName: "",
    contactTypeId: "",
    isParentCompany: "",
    parentCompanyId: "",
    phone1: "",
    phone2: "",
    email1: "",
    email2: "",
    email3: "",
    weburl: "" ,
    linkedurl: "",
    yearfounded: "",
    primarycontact: "",
    noofemployees: "",
    industry: "",
    annualrevenue: "" ,
    ispublic: "",
    notes: "",
    modifiedByUserName: "",
    createdBy: "",
    createdDate: "",   
    modifiedDate: "",
    isActive: "",
  };

  const history = useNavigate();
  const locationData = useLocation();
  const dispatch = useDispatch();
  const params = useParams();
  const companyId = params.CompanyId;

  const [companydetails,SetCompanyDetails]=useState([]);
  const [selectedCompanyType,SetselectedCompanyType]=useState([]);
  const [businessUnit,setBusinessUnit]=useState([]);
  useEffect(() => {
    if(companyId!=0)
    {
    getCompanyDetails(companyId);
    }
    dispatch(getParentCompaniesAction(2));
    getBusinessUnitbycompany(params.CompanyId);
  }, []);



  const getCompanyDetails = async (companyId) => {
    try {
  
        const response = await sbaAxios({
            url: `${getCompanyInfo}${companyId}`,
            method: 'get',
        });
        const data = response;
      
        SetCompanyDetails(data);
        setLoading(false);
    } catch (error) {
        console.error("Error fetching entities from API:", error);
    }
  };

  const getBusinessUnitbycompany= async(companyId)=>
{
  try {

    const response = await sbaAxios({
        url: `${getBusinessUnits}?companyId=${companyId}`,
        method: 'get',
    });
    const data = response;
    const selectedCompanyType=data.filter(item=>item.IsSelected);
    SetselectedCompanyType(selectedCompanyType);
    setBusinessUnit(data);
  
} catch (error) {
    console.error("Error fetching entities from API:", error);
}
}
  const Gstate = useSelector((state) => state) || {};
 
  const ParentCompanies = Gstate?.Contacts.parentCompanies || [];
 
  const salutation = companydetails?.CompanyInfo?.Salutation;
  const companyName = companydetails?.CompanyInfo?.CompanyName;
  const contactTypeId = companydetails?.CompanyInfo?.ContactTypeId;
  const isParentCompany = companydetails?.CompanyInfo?.IsParentCompany;
  const parentCompanyId=companydetails?.CompanyInfo?.ParentCompanyId;
  const phone1=companydetails?.CompanyInfo?.Phone1;
  const phone2 = companydetails?.CompanyInfo?.Phone2;
  const fax=companydetails?.CompanyInfo?.Fax;
  const email1 = companydetails?.CompanyInfo?.Email1;
  const email2 = companydetails?.CompanyInfo?.Email2;
  const email3 = companydetails?.CompanyInfo?.Email3;
  const weburl=companydetails?.CompanyInfo?.WebUrl;
  const linkedurl=companydetails?.CompanyInfo?.LinkedInUrl;
  const yearfounded = companydetails?.CompanyInfo?.YearFounded;
  const primarycontact = companydetails?.CompanyInfo?.PrimaryContact;
  const noofemployees = companydetails?.CompanyInfo?.NumberOfEmployees;
  const industry= companydetails?.CompanyInfo?.Industry;
  const annualrevenue=companydetails?.CompanyInfo?.AnnualRevenue;
  const ispublic=companydetails?.CompanyInfo?.IsPublic;
  const notes=companydetails?.CompanyInfo?.CompanyNotes;
  const createdByUserName = companydetails?.CompanyInfo?.CreatedByName;
  const createdDate = companydetails?.CompanyInfo?.CreatedDate;
  const modifiedByUserName = companydetails?.CompanyInfo?.ModifiedByName;
  const modifiedDate = companydetails?.CompanyInfo?.ModifiedDate;
  const isActive =companydetails?.CompanyInfo?.IsActive;
  
  const [loading, setLoading] = useState(true);
  const [generalState, setGeneralState] = useState(emptyCompanyDetails);
  const [selectedCompanies, setSelectedCompanies] = useState(null);

  // const getCompanyData = (parentCompanies) => {
  //   const selectedCompany = ParentCompanies.find(company => company.ContactId === parentCompanies);
  //   return selectedCompany || {};
  // };

  useEffect(() => {
    companydetails && setLoading(false);
  }, [companydetails]);


  useEffect(() => {
    if (params.CompanyId !== "0") {
      setGeneralState({
        salutation: salutation,
        companyName: companyName,
        isParentCompany: isParentCompany,
        parentCompanyId: parentCompanyId,
        phone1: phone1,
        phone2: phone2,
        email1: email1,
        email2: email2,
        email3: email3,
        weburl: weburl,
        fax: fax,
        linkedurl: linkedurl,
        yearfounded: yearfounded,
        primarycontact: primarycontact,
        noofemployees: noofemployees,
        industry: industry,
        annualrevenue: annualrevenue,
        ispublic: ispublic,
        notes: notes,
        modifiedByUserName: modifiedByUserName,
         createdByUserName: createdByUserName,
        createdDate: createdDate,
        modifiedDate: modifiedDate,
        isActive: isActive,
      });
      const selectedCompany = ParentCompanies.find(company => company.CompanyId === parentCompanyId);
      setSelectedCompanies(selectedCompany);
     
    }
  }, [companydetails]);

  const redirectLinkClick = () => {
    if (companyId !== "0") {
      history(`${UrlPath.CompanyDetails}${companyId}?ContactTypeId=2`);
    } else {
      history(`${UrlPath.Investor}`);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setGeneralState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const parentCompanyCheckbox = (e) => {
    const { name, checked } = e.target;
    if (checked === true) {
      const updatedState = {
        ...generalState,
        [name]: checked,
        ["parentCompanyId"]: "",
      };
      setSelectedCompanies({CompanyName: "", CompanyId: ""})    
      setGeneralState(updatedState);
    } else {
      const updatedState = { ...generalState, [name]: checked };
      setGeneralState(updatedState);
    }
  };

  const businessUnitDropdownChange = (e) => {
    const isSelectedCompanies=businessUnit.filter(item=>item.IsSelected); 
    const isSelectedDisableCompanies=isSelectedCompanies.filter(item=>item.IsSelected && !item.IsEnabled);
    const EditableCompanies=e.value.filter(item=>item.IsEnabled);
    SetselectedCompanyType([...isSelectedDisableCompanies,...EditableCompanies]);
    // const selectedValue=e.value.filter(item=>item.IsSelected && !item.IsEnabled);
    // SetselectedCompanyType([...IsEnabledCompanyTypes,...e.value]);
    
};
  const handleCheckbox = (e) => {
    const { name, checked } = e.target;
    const value =  !checked ? false : true;
    const updatedState = { ...generalState, [name]: value };
    setGeneralState(updatedState);
  };

  const handleDropdown = (e, fieldName) => {
    const CompanyId = e?.value?.CompanyId || 0;
    const CompanyName = e?.value?.CompanyName || "";
    const updatedState = { ...generalState, [fieldName]: CompanyId };
    const newValue = {CompanyName: CompanyName ,CompanyId: CompanyId};
    setSelectedCompanies(newValue);   
    setGeneralState(updatedState);
  };

 
 

  const handleSave = async () => {
    const companyTypeId = selectedCompanyType?.map(item => item.CompanyTypeId).join(',');
    let saveSuccess = true;

    const data = {
      companyId: companyId,
        companyName: generalState.companyName,
        contactTypeId: 2,
        isParentCompany: generalState.isParentCompany || 0,
        parentCompanyId: selectedCompanies?.CompanyId || 0,
        businessUnit: companyTypeId,
        phone1: generalState.phone1,
        phone2: generalState.phone2,
        email1: generalState.email1,
        email2: generalState.email2,
        email3: generalState.email3,
        Fax: generalState.fax,
        weburl: generalState.weburl ,
        LinkedInUrl: generalState.linkedurl,
        yearfounded: generalState.yearfounded,
        primarycontact: generalState.primarycontact,
        NumberOfEmployees: generalState.noofemployees,
        Industry: generalState.industry,
        annualrevenue: generalState.annualrevenue ,
        IsPublic: generalState.ispublic || 0,
        CompanyNotes: generalState.notes,
        modifiedByUserName: generalState.modifiedByUserName,
        createdByUserName: generalState.createdByUserName,
        createdDate: generalState.createdDate || new Date(),   
        modifiedDate: generalState.modifiedDate || new Date(),
      }
     


    const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;
    const phonenoRegex =
      /^(([+]?([0-9]{1,3}))?[-. ])?(\([0-9]{3}\)|[0-9]{3})[-. ]?(\([0-9]{3}\)|[0-9]{3})[-. ]?(\([0-9]{4}\)|[0-9]{4})$/;

    if(!generalState.companyName || generalState.companyName.trim() === "")
    {
      SBNotify({ type: "error", Msg: "Please Enter Company" });
      saveSuccess = false;
    }

    if (generalState.email1 !== "" && !emailRegex.test(generalState.email1)) {
      SBNotify({ type: "error", Msg: "Please Enter Valid Email Address in Email1" });
      saveSuccess = false;
    }
    if (generalState.email2 !== "" && !emailRegex.test(generalState.email2)) {
      SBNotify({ type: "error", Msg: "Please Enter Valid Email Address in Email2" });
      saveSuccess = false;
    }
    if (generalState.email3 !== "" && !emailRegex.test(generalState.email3)) {
      SBNotify({ type: "error", Msg: "Please Enter Valid Email Address in Email3" });
      saveSuccess = false;
    }
    if (generalState.phone1 !== "" && !phonenoRegex.test(generalState.phone1)) {
      SBNotify({ type: "error", Msg: "please Enter Valid Phone No in phone1" });
      saveSuccess = false;
    }
    if (generalState.phone2 !== "" && !phonenoRegex.test(generalState.phone2)) {
      SBNotify({ type: "error", Msg: "please Enter Valid Phone No in phone2" });
      saveSuccess = false;
    }
  if (saveSuccess) {
    const response = await sbaAxios({
      url: `${insertorupdatecompany}`,
      method: "post",
      data: data,
    });
    if (response > 0) {
      SBNotify({ type: "success", Msg: "Updated Successfully" });
      redirectLinkClick();
    }
    else if(response===-2) {
      SBNotify({ type: "error ", Msg: "Unable to add Company.  The company name is already being used." });
    }
      else {
        SBNotify({ type: "error", Msg: "Some Expection occured While Saving Please contact admin" });
      }
    }  

  };

  return (
    <>
      {loading ? (
        <>
          <LoadingScreen />
        </>
      ) : (
        <div id="contacts" className="mainContentData">
          <div className="bg-white m-3 p-border rounded">
            <div className="bg-white p-4">
              <div className="content-container">
                <div className="col-lg-12 px-0">
                  <div className="row m-0">
                    <div className="col-md-4">
                    <div className="mb-4">
                        <span className="fw-medium">Company</span>
                        <span class="mandatory">*</span>
                        <input
                          className="form-control w-75"
                          type="text"
                          name="companyName"
                          Value={generalState.companyName}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                    <div className="mb-4">
                        <div className="d-flex align-items-center">
                          <span
                            className="fw-medium mr-30"
                            style={{ marginRight: "10px" }}
                          >
                            Parent Company
                          </span>
                          <span>
                            <input
                              type="checkbox"
                              name="isParentCompany"
                              checked={generalState.isParentCompany === true}
                              onChange={parentCompanyCheckbox}
                            />
                          </span>
                        </div>
                        <div>
                          <SBAComboBox
                            className="w-75"
                            data={ParentCompanies}
                            textField={"CompanyName"}
                            valueField={"CompanyId"}
                            name="parentCompanyId"
                            value={selectedCompanies}
                            onChange={(e) =>
                              handleDropdown(e, "parentCompanies")
                            }
                            disabled={generalState.isParentCompany === true}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                    <div className="mb-4">
                        <span className="fw-medium">Business Unit</span>
                        <div>
                        <SBAMultiSelectCheck
                                                            className="w-75"
                                                            data={businessUnit}
                                                            dataItemKey={"CompanyTypeId"}
                                                            textField={"CompanyTypeName"}
                                                            onChange={businessUnitDropdownChange}
                                                            value={selectedCompanyType}
                                                            tags={
                                                              selectedCompanyType?.length > 0
                                                                    ? [
                                                                        {
                                                                            text: `${selectedCompanyType.length} items selected`,
                                                                            data: [...selectedCompanyType],
                                                                        },
                                                                    ]
                                                                    : []
                                                            }
                                                            filterable={true}
                                                        />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="col-lg-12 px-0">
                  <div className="row m-0">
                    <div className="col-md-4">
                      <div className="mb-4">
                        <span className="d-flex">
                          <span className="fw-medium">Phone 1</span>
                          <span
                            className="ms-2 roundedIcon"
                            title={`Supported Formats: 
                          +00 000 000 0000
                          +0 0000000000
                          000-000-0000
                          000 000 0000
                          (000) 000 0000
                          (000) (000) (0000)`}
                          >
                            ?
                          </span>
                        </span>
                        <input
                          className="form-control w-75"
                          type="text"
                          name="phone1"
                          Value={generalState.phone1}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-4">
                        <span className="d-flex">
                          <span className="fw-medium">Phone 2</span>
                          <span
                            className="ms-2 roundedIcon"
                            title={`Supported Formats: 
                          +00 000 000 0000
                          +0 0000000000
                          000-000-0000
                          000 000 0000
                          (000) 000 0000
                          (000) (000) (0000)`}
                          >
                            ?
                          </span>
                        </span>
                        <input
                          className="form-control w-75"
                          type="text"
                          name="phone2"
                          Value={generalState.phone2}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-4">
                        <span className="fw-medium">Fax Number</span>
                        <input
                          className="form-control w-75"
                          type="text"
                          name="fax"
                          Value={generalState.fax}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-12 px-0">
                  <div className="row m-0">
                    <div className="col-md-4">
                      <div className="mb-4">
                        <span className="fw-medium">Email</span>
                        <input
                          className="form-control w-75"
                          type="text"
                          name="email1"
                          Value={generalState.email1}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-4">
                        <span className="fw-medium">Email 2</span>
                        <input
                          className="form-control w-75"
                          type="text"
                          name="email2"
                          Value={generalState.email2}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-4">
                        <span className="fw-medium">Email 3</span>
                        <input
                          className="form-control w-75"
                          type="text"
                          name="email3"
                          Value={generalState.email3}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="col-lg-12 px-0">
                  <div className="row m-0">
                    <div className="col-md-4">
                      <div className="mb-4">
                        <span className="fw-medium">Year Founded</span>
                        <input
                          className="form-control w-75"
                          type="text"
                          name="yearfounded"
                          Value={generalState.yearfounded}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="mb-4">
                        <span className="fw-medium">Industry</span>
                        <input
                          className="form-control w-75"
                          type="text"
                          name="industry"
                          Value={generalState.industry}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="mb-4">
                        <span className="fw-medium">Annual Revenue</span>
                        <input
                          className="form-control w-75"
                          type="text"
                          name="annualrevenue"
                          Value={generalState.annualrevenue}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-4">
                        <span className="fw-medium">Primary Contact</span>
                        <input
                          className="form-control w-75"
                          type="text"
                          name="primarycontact"
                          Value={generalState.primarycontact}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="mb-4">
                        <span className="fw-medium">Web URL</span>
                        <input
                          className="form-control w-75"
                          type="text"
                          name="weburl"
                          Value={generalState.weburl}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="mb-4">
                        <span className="fw-medium">Is Public</span>
                        <div>
                          <input
                            type="checkbox"
                            name="ispublic"
                            checked={generalState.ispublic === true}
                            onChange={handleCheckbox}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-4">
                        <span className="fw-medium">Number of Employees</span>
                        <input
                          className="form-control w-75"
                          type="text"
                          name="noofemployees"
                          Value={generalState.noofemployees}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="mb-4">
                        <span className="fw-medium">LinkedIn URL</span>
                        <input
                          className="form-control w-75"
                          type="text"
                          name="linkedurl"
                          Value={generalState.linkedurl}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="col-lg-12 px-0">
                  <div className="row m-0">
                    <div className="col-md-4">
                      <div className="mb-4">
                        <span className="fw-medium">Created by</span>
                        <input
                          className="form-control w-75"
                          type="text"
                          name="createdByUserName"
                          Value={generalState.createdByUserName}
                          disabled
                        />
                      </div>
                      <div className="mb-4">
                        <span className="fw-medium">Modified By</span>
                        <input
                          className="form-control w-75"
                          type="text"
                          name="modifiedBy"
                          Value={generalState.modifiedByUserName}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-4">
                        <span className="fw-medium">Created Date</span>
                        <input
                          className="form-control w-75"
                          type="text"
                          Value={generalState.createdDate ? moment(generalState.createdDate).format(
                            "MM/DD/yyyy"
                          ) : "-"}
                          disabled
                        />
                      </div>
                      <div className="mb-4">
                        <span className="fw-medium">Modified Date</span>
                        <input
                          className="form-control w-75"
                          type="text"
                          name="modifiedDate"
                          Value={generalState.modifiedDate ? moment(generalState.modifiedDate).format(
                            "MM/DD/yyyy"
                          ) : "-"}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="col-lg-12">
                        <div className="mb-4">
                          <label>
                            <span className="fw-medium">Notes</span>
                            <textarea
                              className="form-control"
                              style={{ height: "110px", width: "50vh" }}
                              name="notes"
                              defaultValue={generalState.notes}
                              onChange={handleChange}
                            ></textarea>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-12 px-0">
            <UpdateorCancelButtons
              onSave={handleSave}
              onCancel={redirectLinkClick}
            />
          </div>
        </div>
      )}
      <ToastContainer />
    </>
  );
};
